<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="CPA 5G SA新規契約"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <div class="mx-4">
                  <h3>CPA 5G SA約款確認</h3>
                  <v-row>
                    <v-col cols="7" class="mx-2 my-2">
                      <label
                        >リモートアクセスサービス契約約款&nbsp;&nbsp;確認</label
                      >
                    </v-col>
                    <v-col cols="3">
                      <v-btn
                        :disabled="form.isClauseAgreement"
                        color="primary"
                        @click="confirmTermsAndConditions"
                        >約款確認</v-btn
                      >
                    </v-col>
                  </v-row>
                </div>
                <template v-if="form.isClauseAgreement">
                  <div class="ml-8">
                    <span class="text-red">約款に同意しました。</span>
                  </div>
                </template>
                <template v-if="agreementAlert">
                  <div class="ml-8">
                    <span class="text-red">約款を確認し同意してください。</span>
                  </div>
                </template>
                <div>
                  <div class="mx-4">
                    <h3 class="my-2">CPA 5G SA契約</h3>

                    <!-- 契約 -->
                    <v-row>
                      <v-col>
                        <app-badge item="契約" :isInfo="false" />
                        <validation-provider
                          name="contractType"
                          v-model="form.contractType"
                          label="契約"
                          :rules="{
                            required: form.isClauseAgreement,
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-select
                            item-title="text"
                            item-value="value"
                            :items="[
                              { text: '', value: '' },
                              ...optionList.contractOptions,
                            ]"
                            :disabled="!form.isClauseAgreement"
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <!-- VPN/VNコード-->
                    <v-row>
                      <v-col>
                        <app-badge
                          item="VPN/VNコード"
                          :isInfo="false"
                          :isRequired="true"
                        />
                        <validation-provider
                          name="vpnVnCode"
                          v-model="form.vpnVnCode"
                          label="VPN/VNコード"
                          :rules="{
                            required: true,
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-select-search
                            item-title="text"
                            item-value="value"
                            :items="vpnVnCodeSelectList"
                            :disabled="!form.isClauseAgreement"
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <!-- 認証タイプ-->
                    <v-row>
                      <v-col>
                        <app-badge item="認証タイプ" :isInfo="false" />
                        <validation-provider
                          name="authenticationType"
                          v-model="form.authenticationType"
                          label="認証タイプ"
                          :rules="{
                            required: form.isClauseAgreement,
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-select
                            item-title="text"
                            item-value="value"
                            :items="[
                              { text: '', value: '' },
                              ...authenticationTypeOptions,
                            ]"
                            :disabled="!form.isClauseAgreement"
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <!-- ドメイン -->
                    <v-row>
                      <v-col>
                        <app-badge
                          item="ドメイン"
                          msg="・半角英数、記号(.)を含む16文字以内
                          ・記号(.)の続けての使用及び先頭、末尾での使用は不可
                          ・末尾が「.gqrs」ではないこと
                          ・数値のみでの入力は不可"
                        />
                        <validation-provider
                          name="domain"
                          v-model="form.domain"
                          label="ドメイン"
                          :rules="{
                            required: form.isClauseAgreement,
                            is_alpha_num_symbol: { symbol: '.' },
                            is_not_num_only: true,
                            is_not_both: { notBoth: '.' },
                            is_not_double_symbol: { symbol: '.' },
                            is_not_end: { endChar: '.gqrs' },
                            max: { length: 16 },
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <v-row>
                            <v-col cols="1" class="mt-2">
                              <span>{{ firstDomain }}</span>
                            </v-col>
                            <v-col cols="11">
                              <app-form-input
                                :disabled="!form.isClauseAgreement"
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                            </v-col>
                          </v-row>
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <!-- 冗長 -->
                    <v-row>
                      <v-col>
                        <app-badge
                          item="冗長"
                          :isRequired="false"
                          :isInfo="false"
                        />
                        <v-radio-group
                          v-model="form.redundancy"
                          :disabled="!form.isClauseAgreement"
                          hide-details
                        >
                          <v-radio
                            label="東日本ACT/西日本SBY"
                            value="EAST_ACT_WEST_SBY"
                          />
                          <v-radio
                            label="西日本ACT/東日本SBY"
                            value="WEST_ACT_EAST_SBY"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <!-- 品目 -->
                    <v-row>
                      <v-col>
                        <app-badge
                          item="品目"
                          :isRequired="false"
                          :isInfo="false"
                        />
                        <v-radio-group
                          v-model="form.bandwidthType"
                          :disabled="!form.isClauseAgreement"
                          hide-details
                        >
                          <v-radio
                            label="ベストエフォート"
                            value="BEST_EFFORT"
                            v-if="form.authenticationType !== 'HOMERADIUS'"
                          />
                          <v-radio label="帯域確保" value="SECURING" />
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <!-- アドレスアサイン方式 -->
                    <v-row>
                      <v-col>
                        <app-badge
                          item="アドレスアサイン方式"
                          :isRequired="false"
                          :isInfo="false"
                        />
                        <v-radio-group
                          v-model="form.addressAssignmentMethod"
                          :disabled="!form.isClauseAgreement"
                          hide-details
                        >
                          <v-radio
                            v-for="(
                              AddressAssignOption, index
                            ) in optionList.infoAddressAssignOptions"
                            :key="`${AddressAssignOption.text + index}`"
                            :label="AddressAssignOption.text"
                            :value="AddressAssignOption.value"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <!-- IPアドレス -->
                    <v-row>
                      <v-col>
                        <app-badge
                          item="IPアドレス"
                          :isRequired="false"
                          :isInfo="false"
                        />
                        <v-radio-group
                          v-model="form.ipAddressType"
                          :disabled="!form.isClauseAgreement"
                          hide-details
                        >
                          <v-radio label="IPv4" value="IPV4" />
                          <v-radio
                            label="IPv6"
                            value="IPV6"
                            v-if="
                              cpaOptions.isEnabledIpv6Option &&
                              form.authenticationType !== 'HOMERADIUS' &&
                              form.authenticationType !== 'HOME'
                            "
                          />
                          <v-radio
                            label="IPv4 / IPv6"
                            value="IPV4_IPV6"
                            v-if="cpaOptions.isEnabledIpv6Option"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">契約</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import "vuetify/lib/styles/main.sass";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { VpnVnCode } from "@/apis/InformationApi";
import SaContractConfirm from "@/modals/cpa5g/SaContractConfirm.vue";
import SaContractTermsConfirm from "@/modals/cpa5g/SaContractTermsConfirm.vue";
import { optionList } from "@/views/nwSetting/cpa5gSa/Cpa5gSaContractList.vue";
import type { CpaContractOptions, CreateCpaContract } from "@/apis/Cpa5gSaApi";

export default defineComponent({
  name: "SaContractRegister",
  props: {},
  data() {
    return {
      isLoaded: false,
      agreementAlert: false,
      form: {
        isClauseAgreement: false,
        redundancy: "WEST_ACT_EAST_SBY",
        bandwidthType: "BEST_EFFORT",
        addressAssignmentMethod: "FIXED_IP",
        ipAddressType: "IPV4",
      } as CreateCpaContract,
      optionList: optionList,
      cpaOptions: {} as CpaContractOptions,
      vpnVnCodeList: [] as VpnVnCode[],
    };
  },
  computed: {
    // 契約項目が変更になるたびに表示の切り替えが必要なのでcomputedで作成
    firstDomain(): string {
      switch (this.form.contractType) {
        case "CPA_NO_LIMIT":
          return "cpx.";
        case "CPA_LIMIT_MODULE":
          return "crx.";
        case "CPA_LIMIT_AUDIO":
          return "cvx.";
        default:
          return "";
      }
    },
    // 追加認証タイプ利用フラグがtrueの場合のみ、Homeradius認証と端末認証（Home）が設定可能
    authenticationTypeOptions() {
      return this.cpaOptions.isEnabledAuthenticationOption
        ? this.optionList.authOptions
        : this.optionList.authOptions.filter(
            (option) => !["HOMERADIUS", "HOME"].includes(option.value)
          );
    },
    vpnVnCodeSelectList(): {
      value: string;
      text: string;
    }[] {
      return this.vpnVnCodeList.map((v) => {
        if (v.vnName) {
          return {
            value: v.vpnVnCode,
            text: v.vpnVnCode + "(" + v.vnName + ")",
          };
        } else {
          return { value: v.vpnVnCode, text: v.vpnVnCode };
        }
      });
    },
  },
  watch: {
    /**
     * 認証タイプがHomeRADIUS認証の場合
     * ・ベストエフォートは設定不可(非表示) → 初期値を「帯域確保」に変更
     * ・IPv6(IPv4/IPv6は可)は設定不可(非表示) → IPv6が選択されていた場合、初期値を「IPv4」に変更
     * 認証タイプが端末認証(Home)の場合
     * ・IPv6(IPv4/IPv6は可)は設定不可(非表示) → IPv6が選択されていた場合、初期値を「IPv4」に変更
     */
    "form.authenticationType": function (newval: string, oldVal: string) {
      if (newval === "HOMERADIUS") {
        this.form.bandwidthType = "SECURING";
        if (this.form.ipAddressType === "IPV6") {
          this.form.ipAddressType = "IPV4";
        }
      } else if (oldVal === "HOMERADIUS") {
        this.form.bandwidthType = "BEST_EFFORT";
      } else if (newval === "HOME" && this.form.ipAddressType === "IPV6") {
        this.form.ipAddressType = "IPV4";
      }
    },
    "form.isClauseAgreement": function (val: boolean) {
      this.agreementAlert = !val;
    },
  },
  async mounted() {
    this.cpaOptions = await this.$api.cpa5gSa.getCpaContractOptions();
    // VPN/VNコードの取得
    this.vpnVnCodeList = (await this.$api.information.getVpnVnCodeList())
      .filter((v) => v.vnType === "L3" || v.vnType === null)
      .sortBy(["vpnVnCode", "asc"]);
    this.isLoaded = true;
  },
  methods: {
    async submit() {
      if (!this.form.isClauseAgreement) this.agreementAlert = true;

      if (this.form.isClauseAgreement) {
        const displayVnName = this.vpnVnCodeList.find(
          (v) => v.vpnVnCode === this.form.vpnVnCode
        )?.vnName;
        // 確認画面の呼び出し
        await this.$modal.show(SaContractConfirm, {
          cpa5gContractData: {
            ...this.form,
            domain: this.firstDomain + this.form.domain,
          },
          displayVnName: displayVnName,
        });
        // 確認画面の「はい」が押されたらAPIを呼び出す、確認画面を閉じる
        await this.$api.cpa5gSa.createCpaContract({
          ...this.form,
          domain: this.firstDomain + this.form.domain,
        });
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      }
    },
    // 約款確認
    async confirmTermsAndConditions() {
      await this.$modal.show(SaContractTermsConfirm);
      this.form.isClauseAgreement = true;
    },
  },
});
</script>
